// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3OlhO","tab":"ProcedureTabs_tab__3u9VI"};